import * as React from "react";
import { SVGProps } from "react";

export const IconRetry = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 5.833V0l-2.2 2.2A7.447 7.447 0 007.5 0 7.5 7.5 0 1015 7.5h-1.667A5.84 5.84 0 017.5 13.333 5.84 5.84 0 011.667 7.5 5.84 5.84 0 017.5 1.667c1.608 0 3.067.658 4.125 1.708L9.167 5.833H15z"
      fill="#828282"
    />
  </svg>
);
